<template>
    <section class="bgModal">
        <section class="modal">
            <span class="textLoader">{{ $t('language.posadasCorporate.login.loader') }}</span>
            <span class="loader"></span>
        </section>
    </section>
</template>

<script>
import i18n from '../../plugins/i18n';

    export default {
        name: 'loader',
        props: ['tipo'],

    }
</script>

<style lang="scss" scoped>
@import '../../assets/scss/config.scss';
.textLoader {
    font-family: Roboto;
    font-size: $font-size-base;
    line-height: 1.29;
    letter-spacing: 0.4px;
    color: $grayBrownish;
    text-align: center;
}

.bgModal {
    opacity: .8;
}

/* Bloques */
.modal {
    display: flex;
    position: relative;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    width: 32em;
    max-width: 100%;
    padding: 1.25em;
    border: none;
    border-radius: .3125em;
    background: #fff;
    font-family: inherit;
    font-size: 1rem;
    margin: auto;
    opacity: .8;
    width: 100%;
    height: 100%;
}

.cirreIcon{
    position: absolute;
    right: 10px;
    top: 10px;
}
.cirreIcon::before{
    font-size: $font-size-h3;
    color: $colorBase2;
}

/* Elementos */
.modal__header {
    position: relative;
    max-width: 100%;
    margin: 0 0 .4em;
    padding: 0;
    color: $colorBase1;
    text-transform: none;
    word-wrap: break-word;
    font-size: $font-size-exlarge !important;
    margin-bottom: 15px;
    margin-top: 20px;
}

.modal__contenido {
    z-index: 1;
    justify-content: center;
    margin: 0;
    padding: 0;
    margin-bottom: 30px;
    color: #545454;
    font-size: 1.125em;
    font-weight: 300;
    line-height: normal;
    word-wrap: break-word;
}


@media only screen and (max-width: 992px) {
    .btn-cancel, .btn-confirm {
        width: 100%;
    }
    .btn-cancel {
        order: 2
    }
    .btn-confirm {
        order: 1;
    }
}
/* Modificadores */
/* Estilo */
.modal--exito {
    color: #006900;
}

.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.loader {
  color: #757575;
  font-size: 10px;
  margin: 0px auto 30px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

// estilos para IE
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .modal {
    padding-bottom: 55px;
  }
}
</style>